<ul class="breadcrumb">
  <li class="breadcrumb-item wizard">Pre-Log Entry</li>
  <li class="breadcrumb-item wizard inactive"><i class="fa fa-chevron-right"></i>Review Entry</li>
  <li class="breadcrumb-item wizard inactive"><i class="fa fa-chevron-right"></i>Ready to Send Sample</li>
  <li class="ms-auto"><a href="#" (click)="open($event, prelogtips)"><i class="fa fa-info-circle" style="width: 20px;"></i>Pre-Log Tips</a></li>
  <li class="ms-3">@if (externalLinks) {
    <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
  }</li>
</ul>
<div class="text-center">
  <h1>Pre-Log Entry</h1>
  <p>Before opening a buccal DNA collection kit and entering sample information, please use <a routerLink="/sample-search">DNA Data Bank Sample Search</a> to check if it has already been submitted.</p>
</div>
@if (errorMessage) {
  <div class="col-12 col-lg-6 offset-lg-3 alert alert-danger">{{errorMessage}}</div>
}
<div class="row">
  <div class="form-group col-12 col-md-6 col-xl-3">
    <label for="date-entered">Date Entered</label>
    <div class="data-label">{{ dateEntered | date: 'M/d/yyyy' }}</div>
  </div>
  <div class="form-group col-12 col-md-6 col-xl-3">
    <label for="entered-by">Entered By</label>
    <div class="data-label">{{ enteredBy }}</div>
  </div>
  <div class="form-group col-12 col-md-6 col-xl-3">
    <label for="agency-name">Agency Name</label>
    <div class="data-label">{{ agencyName }}</div>
  </div>
</div>
<form [formGroup]="preLogForm">
  <div class="row">
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="barcode">Buccal Collector Barcode #</label>
      <input type="text" id="barcode" #barcodeField formControlName="kitBarcode" class="form-control" maxlength="40" appBlockClipboard [class.is-invalid]="showValidation && kitBarcode.invalid" (change)="checkDuplicateBarcode()" (keydown.enter)="onBarcodeEnterKey()" oninput="this.value = this.value.toUpperCase()" />
      @if (showValidation && kitBarcode.hasError('required')) {
        <small class="text-danger">Buccal Collector Barcode # is required</small>
      }
    </div>
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="confirm-barcode">Submission Form Barcode #</label>
      <input type="text" id="confirm-barcode" #confirmBarcodeField formControlName="confirmKitBarcode" class="form-control" maxlength="40" appBlockClipboard [class.is-invalid]="confirmKitBarcode.touched && (preLogForm.hasError('match') || confirmKitBarcode.invalid)" (change)="checkDuplicateBarcode()" (keydown.enter)="onConfirmBarcodeEnterKey()" oninput="this.value = this.value.toUpperCase()" />
      @if (barcodeWorking) {
        <i class="fa fa-spinner fa-spin text-overlay"></i>
      }
      @if (confirmKitBarcode.touched && preLogForm.hasError('match')) {
        <small class="text-danger">Buccal Collector Barcode # and Submission Form Barcode # do not match</small>
      }
      @if (confirmKitBarcode.invalid && confirmKitBarcode.hasError('duplicateBarcode')) {
        <small class="text-danger">This Kit Barcode # has already been used</small>
      }
    </div>
    @if (showVACORISNumber) {
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label for="doc-number">VACORIS #</label>
        <input type="text" id="doc-number" #docNumberField formControlName="docNumber" class="form-control" maxlength="11" (blur)="checkDocNumber()" />
        @if (docNumberWorking) {
          <i class="fa fa-spinner fa-spin text-overlay"></i>
        }
        @if (docNumberNotFound) {
          <small class="text-warning">VACORIS # not found</small>
        }
      </div>
    }
  </div>
  <div class="row">
    <div class="col-12 col-xl-6">
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label for="last-name">Last Name</label>
          <input type="text" id="last-name" #lastNameField formControlName="lastName" class="form-control" maxlength="50" [class.is-invalid]="showValidation && lastName.invalid" oninput="this.value = this.value.toUpperCase()" />
          @if (showValidation && lastName.hasError('required')) {
            <small class="text-danger">Last Name is required</small>
          }
        </div>
        <div class="form-group col-12 col-md-6">
          <label for="first-name">First Name</label>
          <input type="text" id="first-name" formControlName="firstName" class="form-control" maxlength="25" [class.is-invalid]="showValidation && firstName.invalid" oninput="this.value = this.value.toUpperCase()" />
          @if (showValidation && firstName.hasError('required')) {
            <small class="text-danger">First Name is required</small>
          }
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label for="middle-initial">Middle Initial</label>
          <input type="text" id="middle-initial" formControlName="middleInitial" class="form-control" maxlength="1" [class.is-invalid]="showValidation && middleInitial.invalid" oninput="this.value = this.value.toUpperCase()" />
        </div>
        <div class="form-group col-12 col-md-6">
          <label for="suffix">Suffix</label>
          <select id="suffix" formControlName="nameSuffix" class="form-select">
            <option [ngValue]="undefined"></option>
            @for (suffix of suffixes; track suffix) {
              <option [ngValue]="suffix">{{ suffix }}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="form-group col-12 col-xl-6">
      <div class="row">
        <div class="col-8 col-md-6">
          <label for="aliases">Aliases</label>
          <select id="aliases" formControlName="aliasList" class="form-select" style="height: 78px; overflow: auto;" size="3" readonly>
            @for (alias of aliases; track alias) {
              <option>{{ alias }}</option>
            }
          </select>
        </div>
        <div class="col-4 col-md-3">
          <button type="button" class="btn btn-primary" style="display: block; margin-top: 30px;" title="Add an Alias" (click)="addAlias()"><i class="fa fa-plus"></i> Add</button>
          <button type="button" class="btn btn-primary" style="margin-top: 10px" title="Remove the selected Alias" (click)="removeAlias()"><i class="fa fa-times"></i> Remove</button>
        </div>
      </div>
      @if (showRemoveError) {
        <small class="text-warning">You must select an Alias to remove</small>
      }
      @if (showDuplicateError) {
        <small class="text-warning">The entered Alias is already in the list</small>
      }
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="gender">Gender</label>
      <select id="gender" formControlName="gender" class="form-select" [class.is-invalid]="showValidation && gender.invalid">
        <option [ngValue]="undefined"></option>
        @for (gender of genders; track gender) {
          <option [ngValue]="gender.code">{{ gender.name }}</option>
        }
      </select>
      @if (showValidation && gender.hasError('required')) {
        <small class="text-danger">Gender is required</small>
      }
    </div>
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="race">Race</label>
      <select id="race" formControlName="race" class="form-select" [class.is-invalid]="showValidation && race.invalid">
        <option [ngValue]="undefined"></option>
        @for (race of races; track race) {
          <option [ngValue]="race.id">{{ race.name }}</option>
        }
      </select>
      @if (showValidation && race.hasError('required')) {
        <small class="text-danger">Race is required</small>
      }
    </div>
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="date-of-birth">Date of Birth</label>
      <div class="input-group">
        <input type="text" id="date-of-birth" placeholder="mm/dd/yyyy" formControlName="dateOfBirth" class="form-control" ngbDatepicker [maxDate]="today" #dobPicker="ngbDatepicker" [class.is-invalid]="showValidation && (dateOfBirth.invalid || preLogForm.hasError('minAge') || preLogForm.hasError('maxAge'))" (blur)="checkAge()" (dateSelect)="checkAge()" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary text-dropdown" (click)="dobPicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
        </div>
      </div>
      @if (showValidation && dateOfBirth.hasError('required')) {
        <small class="text-danger">Date of Birth is required</small>
      }
      @if (showValidation && dateOfBirth.hasError('ngbDate') && dateOfBirth.getError('ngbDate')?.invalid && !dateOfBirth.hasError('required')) {
        <small class="text-danger">Date of Birth must be in the format: mm/dd/yyyy</small>
      }
      @if (showValidation && dateOfBirth.hasError('ngbDate') && dateOfBirth.getError('ngbDate')?.requiredAfter) {
        <small class="text-danger">Date of Birth must not be in the future</small>
      }
      @if (showValidation && preLogForm.hasError('minAge')) {
        <small class="text-danger">Minimum Age is {{ minimumAge }}</small>
      }
      @if (showValidation && preLogForm.hasError('maxAge')) {
        <small class="text-danger">Maximum Age is 100</small>
      }
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="ssn">SSN</label>
      <input type="text" id="ssn" mask="000-00-0000" [dropSpecialCharacters]="false" formControlName="ssn" class="form-control" [class.is-invalid]="showValidation && ssn.invalid" (keydown.tab)="ssnKeyDown($event)" />
      @if (showValidation && ssn.invalid) {
        <small class="text-danger">SSN must be in the format: 000-00-0000</small>
      }
    </div>
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="sid">SID</label>
      <input type="text" id="sid" #sidTextbox formControlName="sid" class="form-control" maxlength="10" oninput="this.value = this.value.toUpperCase()" />
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="reason-for-collection">Reason for Collection</label>
      <select id="reason-for-collection" formControlName="reasonForCollection" class="form-select" [class.is-invalid]="showValidation && reasonForCollection.invalid" (change)="onReasonChange()">
        <option [ngValue]="undefined"></option>
        @for (sampleSource of sampleSources; track sampleSource) {
          <option [ngValue]="sampleSource.id">{{ sampleSource.preLogName }}</option>
        }
      </select>
      @if (showValidation && reasonForCollection.hasError('required')) {
        <small class="text-danger">Reason for Collection is required</small>
      }
    </div>
    <div class="form-group col-12 col-md-6 col-xl-3">
      @if (useOffenseDropdown) {
        <label for="qualiying-charge-select">Qualifying Charge/Conviction</label>
      }
      @if (useOffenseDropdown) {
        <ng-select formControlName="qualifyingChargeDropdown" class="form-control" [items]="qualifyingOffenses" [selectOnTab]="true" [searchFn]="searchStartsWithQualifyingOffenses" bindLabel="code" bindValue="id" labelForId="qualiying-charge-select" (change)="onChargeChange()" [class.ng-select-invalid]="showValidation && qualifyingChargeDropdown.invalid">
          <ng-template ng-option-tmp let-item="item">
            <div placement="left" container="body" [ngbTooltip]="item.description" tooltipClass="blue-background">
              <span>{{ item.code }}</span>
            </div>
          </ng-template>
        </ng-select>
      }
      @if (useOffenseDropdown && showValidation && qualifyingChargeDropdown.hasError('required')) {
        <small class="text-danger">Qualifying Charge/Conviction is required</small>
      }
      @if (!useOffenseDropdown) {
        <label for="qualiying-charge">Qualifying Charge/Conviction</label>
      }
      @if (!useOffenseDropdown) {
        <input type="text" id="qualiying-charge" formControlName="qualifyingChargeTextbox" class="form-control" maxlength="23" [class.is-invalid]="showValidation && qualifyingChargeTextbox.invalid" oninput="this.value = this.value.toUpperCase()" />
      }
      @if (!useOffenseDropdown && showValidation && qualifyingChargeTextbox.hasError('required')) {
        <small class="text-danger">Qualifying Charge/Conviction is required</small>
      }
      @if (!useOffenseDropdown && showValidation && qualifyingChargeTextbox.hasError('forbiddenValue')) {
        <small class="text-danger">Please enter the code for the specific charge/conviction.</small>
      }
    </div>
    @if (showRelatedOffense) {
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label for="qualiying-charge-2">Related Qualifying Charge/Conviction</label>
        <ng-select formControlName="qualifyingChargeDropdown2" class="form-control" [items]="nonModifierQualifyingOffenses" [selectOnTab]="true" [searchFn]="searchStartsWithQualifyingOffenses" bindLabel="code" bindValue="id" labelForId="qualiying-charge-2" [class.ng-select-invalid]="showValidation && qualifyingChargeDropdown2.invalid">
          <ng-template ng-option-tmp let-item="item">
            <div placement="left" container="body" [ngbTooltip]="item.description" tooltipClass="blue-background">
              <span>{{ item.code }}</span>
            </div>
          </ng-template>
        </ng-select>
        @if (showValidation && qualifyingChargeDropdown2.hasError('required')) {
          <small class="text-danger">Related Qualifying Charge/Conviction is required</small>
        }
      </div>
    }
    @if (showOffenseFreeText) {
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label for="free-text-charge">{{ freeTextLabel }}</label>
        <input type="text" id="free-text-charge" formControlName="qualifyingChargeFreeText" class="form-control" maxlength="23" [class.is-invalid]="showValidation && qualifyingChargeFreeText.invalid" oninput="this.value = this.value.toUpperCase()" />
        @if (showValidation && qualifyingChargeFreeText.hasError('required')) {
          <small class="text-danger">{{ freeTextLabel }} is required</small>
        }
        @if (showValidation && qualifyingChargeFreeText.hasError('maxlength')) {
          <small class="text-danger">{{ freeTextLabel }} must not contain more than 23 characters</small>
        }
        @if (showValidation && qualifyingChargeFreeText.hasError('forbiddenValue')) {
          <small class="text-danger">Please enter the code for the specific charge/conviction.</small>
        }
      </div>
    }
    @if (showSORFields) {
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label for="state">State</label>
        <ng-select formControlName="state" class="form-control" [items]="states" [selectOnTab]="true" [searchFn]="searchStartsWithState" bindLabel="abbreviation" bindValue="abbreviation" labelForId="state" [class.ng-select-invalid]="showValidation && state.invalid">
          <ng-template ng-option-tmp let-item="item">
            <span>{{ item.abbreviation + " - " + item.name }}</span>
          </ng-template>
        </ng-select>
        @if (showValidation && state.hasError('required')) {
          <small class="text-danger">State is required</small>
        }
      </div>
    }
  </div>
  <div class="row">
    @if (showArresteeFields) {
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label for="arresting-officer">Arresting Officer</label>
        <input type="text" id="arresting-officer" formControlName="arrestingOfficer" class="form-control" maxlength="15" [class.is-invalid]="showValidation && arrestingOfficer.invalid" oninput="this.value = this.value.toUpperCase()" />
        @if (showValidation && arrestingOfficer.hasError('required')) {
          <small class="text-danger">Arresting Officer is required</small>
        }
      </div>
    }
    @if (showArresteeFields) {
      <div class="form-group col-12 col-md-6 col-xl-3">
        <label for="dcn">DCN</label>
        <input type="text" id="dcn" formControlName="dcn" class="form-control" maxlength="7" [class.is-invalid]="showValidation && dcn.invalid" oninput="this.value = this.value.toUpperCase()" />
        @if (showValidation && dcn.hasError('required')) {
          <small class="text-danger">DCN is required</small>
        }
        @if (showValidation && dcn.hasError('pattern')) {
          <small class="text-danger">DCN must contain 7 numbers/letters</small>
        }
      </div>
    }
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="date-collected">Date Collected</label>
      <div class="input-group">
        <input type="text" id="date-collected" placeholder="mm/dd/yyyy" formControlName="dateCollected" class="form-control" ngbDatepicker [minDate]="monthsAgo3" [maxDate]="today" #dcPicker="ngbDatepicker" [class.is-invalid]="showValidation && dateCollected.invalid" (blur)="checkAge()" (dateSelect)="checkAge()" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary text-dropdown" (click)="dcPicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
        </div>
      </div>
      @if (showValidation && dateCollected.hasError('required')) {
        <small class="text-danger">Date Collected is required</small>
      }
      @if (showValidation && dateCollected.hasError('ngbDate') && dateCollected.getError('ngbDate')?.invalid && !dateCollected.hasError('required')) {
        <small class="text-danger">Date Collected must be in the format: mm/dd/yyyy</small>
      }
      @if (showValidation && dateCollected.hasError('ngbDate') && dateCollected.getError('ngbDate')?.requiredBefore) {
        <small class="text-danger">Date Collected must not be more than 3 months ago</small>
      }
      @if (showValidation && dateCollected.hasError('ngbDate') && dateCollected.getError('ngbDate')?.requiredAfter) {
        <small class="text-danger">Date Collected must not be in the future</small>
      }
    </div>
    <div class="form-group col-12 col-md-6 col-xl-3">
      <label for="collected-by">Sample Collected By</label>
      <input type="text" id="collected-by" formControlName="collectedBy" class="form-control" maxlength="50" [class.is-invalid]="showValidation && collectedBy.invalid" oninput="this.value = this.value.toUpperCase()" />
      @if (showValidation && collectedBy.hasError('required')) {
        <small class="text-danger">Sample Collected By is required</small>
      }
      @if (showValidation && collectedBy.hasError('maxlength')) {
        <small class="text-danger">Sample Collected By must not contain more than 50 characters</small>
      }
    </div>
  </div>
  @if (showAgeWarning) {
    <div class="row text-center me-1 ms-1">
      <div class="col-12 alert alert-warning arrestee-warning">
        <p class="mb-1">Arrestee DNA samples are generally NOT collected for individuals under the age of {{ minimumAge }}. Please verify the date of birth for this submission.</p>
        <p class="mb-0">By continuing with this DNA sample submission, you are verifying that the juvenile is being charged as an adult for this offense.</p>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-12 text-end">
      @if (duplicateWorking) {
        <i class="me-2 fa fa-spinner fa-spin"></i>
        }<button type="button" class="btn btn-primary" (click)="onSubmit()">Next <i class="fa fa-chevron-right"></i></button>
        <button type="button" class="btn btn-secondary ms-2" (click)="onClear()">Clear entry</button>
      </div>
    </div>
  </form>
  <ng-template #prelogtips let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Pre-Log Tips</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
    </div>
    <div class="modal-body">
      <app-pre-log-tips></app-pre-log-tips>
    </div>
  </ng-template>
  <app-input-box #addAliasInputBox title="Add Alias" prompt="Enter the Alias" accept-button-caption="Add" max-length="50" (valueText)="addAliasValue($event)"></app-input-box>
  <app-duplicate-sample-popup #duplicateSamplePopup [newSample]="newSample" [duplicateSamples]="duplicateSamples" (continue)="continueToReview()"></app-duplicate-sample-popup>
